import { Constants } from "@eagerdog/constants";
import {
  IsNotEmpty,
  IsIn,
  IsNumber,
  IsOptional,
  IsArray,
  ValidateNested,
} from "class-validator";
import { Type } from "class-transformer";

import { INoseworkFault, INoseworkScore } from "./nosework-score.interface";

export class NoseworkFaultDto implements INoseworkFault {
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_fault_type))
  fault_type: string;

  @IsNumber()
  fault_count: number;
}

export class NoseworkScoreDto implements INoseworkScore {
  /**
   * Constants.score_result_type:
   * Qualified
   * NQ
   * Excused
   * Disqualified
   * Absent
   */
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  result_reason?: string;

  @IsOptional()
  search_time?: string; //mm:ss:tt. Only if result_type == Constants.score_result_type.qualified

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => NoseworkFaultDto)
  faults: NoseworkFaultDto[];

  @IsOptional()
  excluded_from_placement?: boolean;
}
